import { Padding_ZERO_getInstance165tawgk9tdj7 as Padding_ZERO_getInstance } from './DateTimeFormat.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { toString1n9qg6fb0b5i8 as toString } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  isInterface3d6p8outrmvmk as isInterface,
  isArray1hxjqtqy632bc as isArray,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  AlternativesParsingFormatStructure1jbxrbmj8ihe6 as AlternativesParsingFormatStructure,
  OptionalFormatStructure1lur7h5l20ekc as OptionalFormatStructure,
  ConstantFormatStructure2ckhnu4xssh81 as ConstantFormatStructure,
  CachedFormatStructurec5vu2vku3yjz as CachedFormatStructure,
  BasicFormatStructure1rp1tyv3u2fjw as BasicFormatStructure,
} from '../internal/format/FormatStructure.mjs';
import {
  AbstractWithTimeBuilder2vqnew72ok0ro as AbstractWithTimeBuilder,
  FractionalSecondDirective1min2m2ag51uu as FractionalSecondDirective,
} from './LocalTimeFormat.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function year$default(padding, $super) {
  padding = padding === VOID ? Padding_ZERO_getInstance() : padding;
  var tmp;
  if ($super === VOID) {
    this.year_dmdaiv_k$(padding);
    tmp = Unit_instance;
  } else {
    tmp = $super.year_dmdaiv_k$.call(this, padding);
  }
  return tmp;
}
function monthNumber$default(padding, $super) {
  padding = padding === VOID ? Padding_ZERO_getInstance() : padding;
  var tmp;
  if ($super === VOID) {
    this.monthNumber_xjkdp7_k$(padding);
    tmp = Unit_instance;
  } else {
    tmp = $super.monthNumber_xjkdp7_k$.call(this, padding);
  }
  return tmp;
}
var WithYearMonthClass;
function WithYearMonth() {
  if (WithYearMonthClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'WithYearMonth');
    WithYearMonthClass = $;
  }
  return WithYearMonthClass;
}
function day$default(padding, $super) {
  padding = padding === VOID ? Padding_ZERO_getInstance() : padding;
  var tmp;
  if ($super === VOID) {
    this.day_pu15qg_k$(padding);
    tmp = Unit_instance;
  } else {
    tmp = $super.day_pu15qg_k$.call(this, padding);
  }
  return tmp;
}
var WithDateClass;
function WithDate() {
  if (WithDateClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'WithDate', VOID, VOID, [WithYearMonth()]);
    WithDateClass = $;
  }
  return WithDateClass;
}
function hour$default(padding, $super) {
  padding = padding === VOID ? Padding_ZERO_getInstance() : padding;
  var tmp;
  if ($super === VOID) {
    this.hour_cqw3y8_k$(padding);
    tmp = Unit_instance;
  } else {
    tmp = $super.hour_cqw3y8_k$.call(this, padding);
  }
  return tmp;
}
function minute$default(padding, $super) {
  padding = padding === VOID ? Padding_ZERO_getInstance() : padding;
  var tmp;
  if ($super === VOID) {
    this.minute_p09m40_k$(padding);
    tmp = Unit_instance;
  } else {
    tmp = $super.minute_p09m40_k$.call(this, padding);
  }
  return tmp;
}
function second$default(padding, $super) {
  padding = padding === VOID ? Padding_ZERO_getInstance() : padding;
  var tmp;
  if ($super === VOID) {
    this.second_rj6d1s_k$(padding);
    tmp = Unit_instance;
  } else {
    tmp = $super.second_rj6d1s_k$.call(this, padding);
  }
  return tmp;
}
var WithTimeClass;
function WithTime() {
  if (WithTimeClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'WithTime');
    WithTimeClass = $;
  }
  return WithTimeClass;
}
function offsetHours$default(padding, $super) {
  padding = padding === VOID ? Padding_ZERO_getInstance() : padding;
  var tmp;
  if ($super === VOID) {
    this.offsetHours_tq5sq0_k$(padding);
    tmp = Unit_instance;
  } else {
    tmp = $super.offsetHours_tq5sq0_k$.call(this, padding);
  }
  return tmp;
}
function offsetMinutesOfHour$default(padding, $super) {
  padding = padding === VOID ? Padding_ZERO_getInstance() : padding;
  var tmp;
  if ($super === VOID) {
    this.offsetMinutesOfHour_nthfst_k$(padding);
    tmp = Unit_instance;
  } else {
    tmp = $super.offsetMinutesOfHour_nthfst_k$.call(this, padding);
  }
  return tmp;
}
function offsetSecondsOfMinute$default(padding, $super) {
  padding = padding === VOID ? Padding_ZERO_getInstance() : padding;
  var tmp;
  if ($super === VOID) {
    this.offsetSecondsOfMinute_yjq3ot_k$(padding);
    tmp = Unit_instance;
  } else {
    tmp = $super.offsetSecondsOfMinute_yjq3ot_k$.call(this, padding);
  }
  return tmp;
}
var WithUtcOffsetClass;
function WithUtcOffset() {
  if (WithUtcOffsetClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'WithUtcOffset');
    WithUtcOffsetClass = $;
  }
  return WithUtcOffsetClass;
}
function char(_this__u8e3s4, value) {
  return _this__u8e3s4.chars_pe6iqb_k$(toString(value));
}
function optional(_this__u8e3s4, ifZero, format) {
  ifZero = ifZero === VOID ? '' : ifZero;
  var tmp;
  if (isInterface(_this__u8e3s4, AbstractDateTimeFormatBuilder())) {
    _this__u8e3s4.appendOptionalImpl_725ywl_k$(ifZero, typeof format === 'function' ? format : THROW_CCE());
    tmp = Unit_instance;
  } else {
    throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$('impossible');
  }
  return tmp;
}
function alternativeParsing(_this__u8e3s4, alternativeFormats, primaryFormat) {
  var tmp;
  if (isInterface(_this__u8e3s4, AbstractDateTimeFormatBuilder())) {
    var tmp_0 = (isArray(alternativeFormats) ? alternativeFormats : THROW_CCE()).slice();
    _this__u8e3s4.appendAlternativeParsingImpl_9hljk3_k$(tmp_0, typeof primaryFormat === 'function' ? primaryFormat : THROW_CCE());
    tmp = Unit_instance;
  } else {
    throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$('impossible');
  }
  return tmp;
}
function appendAlternativeParsingImpl(otherFormats, mainFormat) {
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(otherFormats.length);
  var inductionVariable = 0;
  var last = otherFormats.length;
  while (inductionVariable < last) {
    var item = otherFormats[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'kotlin.also' call
    var this_0 = this.createEmpty_8k9z67_k$();
    item(this_0);
    var tmp$ret$2 = this_0.get_actualBuilder_7qypdo_k$().build_1k0s4u_k$();
    destination.add_utx5q5_k$(tmp$ret$2);
  }
  var others = destination;
  // Inline function 'kotlin.also' call
  var this_1 = this.createEmpty_8k9z67_k$();
  mainFormat(this_1);
  var main = this_1.get_actualBuilder_7qypdo_k$().build_1k0s4u_k$();
  this.get_actualBuilder_7qypdo_k$().add_b6pdwl_k$(new (AlternativesParsingFormatStructure())(main, others));
}
function appendOptionalImpl(onZero, format) {
  var tmp = this.get_actualBuilder_7qypdo_k$();
  // Inline function 'kotlin.also' call
  var this_0 = this.createEmpty_8k9z67_k$();
  format(this_0);
  tmp.add_b6pdwl_k$(new (OptionalFormatStructure())(onZero, this_0.get_actualBuilder_7qypdo_k$().build_1k0s4u_k$()));
}
function chars(value) {
  return this.get_actualBuilder_7qypdo_k$().add_b6pdwl_k$(new (ConstantFormatStructure())(value));
}
function build() {
  return new (CachedFormatStructure())(this.get_actualBuilder_7qypdo_k$().build_1k0s4u_k$().formats_1);
}
var AbstractDateTimeFormatBuilderClass;
function AbstractDateTimeFormatBuilder() {
  if (AbstractDateTimeFormatBuilderClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'AbstractDateTimeFormatBuilder');
    AbstractDateTimeFormatBuilderClass = $;
  }
  return AbstractDateTimeFormatBuilderClass;
}
function secondFractionInternal(_this__u8e3s4, minLength, maxLength, grouping) {
  (isInterface(_this__u8e3s4, AbstractWithTimeBuilder()) ? _this__u8e3s4 : THROW_CCE()).addFormatStructureForTime_h3r7lv_k$(new (BasicFormatStructure())(new (FractionalSecondDirective())(minLength, maxLength, grouping)));
}
//region block: exports
export {
  day$default as day$default1tuwold9wyz96,
  hour$default as hour$default3ltjmfc740vqh,
  minute$default as minute$defaultsgib3pp3rn60,
  second$default as second$defaultabrspkhk2hrb,
  offsetHours$default as offsetHours$defaultkbnzeiu5kz92,
  offsetMinutesOfHour$default as offsetMinutesOfHour$default10ls43d3hs3kk,
  offsetSecondsOfMinute$default as offsetSecondsOfMinute$default1bdialvaf1bc0,
  monthNumber$default as monthNumber$defaultjiqg7b70p9la,
  year$default as year$default3mx8s1e4np76f,
  appendAlternativeParsingImpl as appendAlternativeParsingImpl1mug8j87kp2j3,
  appendOptionalImpl as appendOptionalImplcg29ds00y54b,
  build as build284bs2tzkjm2x,
  chars as chars1g48a4lypizqb,
  AbstractDateTimeFormatBuilder as AbstractDateTimeFormatBuilder2kkelk07l4wb,
  WithDate as WithDate2bqihss8t5xfv,
  WithTime as WithTime2lgb7k6hqa1zi,
  WithUtcOffset as WithUtcOffset30ws1ntcash0j,
  WithYearMonth as WithYearMonth35cttdg68tw6f,
  alternativeParsing as alternativeParsing1gmwubnsvpp9b,
  char as char1r4ssccmdfesy,
  optional as optional3j6ywsx1pxeh6,
  secondFractionInternal as secondFractionInternalr53tad5c19e9,
};
//endregion

//# sourceMappingURL=DateTimeFormatBuilder.mjs.map
